module.exports = __webpack_public_path__ + "img/app-dl-badge_apple-store.2928664f.svg";